import { makeLoader, normalizeForLoader } from '@lib/common';
import DataLoader from 'dataloader';
import { map as rxjsMap } from 'rxjs/operators';
import * as contentService from '@api/content';
import { ExpiryMap } from '@lib/common/expiry-map';

/**
 * NOTE: This is a dummy dataloader, as you can see it does not actually utilize the
 * dataloader paradim. This will be replaced with actual pint/deli APIs when have a
 * batch api to get the results.
 */
export const contentDataLoader = new DataLoader(
  (ids: string[]) =>
    contentService
      .filter_compact({
        filters: [
          {
            id: 'vtr_id',
            value: {
              $in: ids.join(','),
            },
          },
        ],
        pageSize: ids.length > 10 ? ids.length : 10,
      })
      .pipe(
        rxjsMap(res =>
          res.data.data.map(res => ({
            ...res,
            // content_type: res.content_type == 0 ? 'Movie' : 'TV Series', // Overriding 0 and 1 coming from DELI Content Search API
            content_type: res.content_type == 0 ? 'Movie' : res.content_type == 2 ? 'Book' : res.content_type == 3 ? 'Podcast' : res.content_type == 4 ? 'Game' : res.content_type == 5 ? 'Format': res.content_type == 6 ? 'Story' :res.content_type == 7 ? 'IP' : res.content_type == 8 ? 'Micro-Series': 'TV Series',
            release_date: res.release_date || '',
          }))
        ),
        normalizeForLoader(
          ids,
          cmp => cmp.vtr_id,
          id => new Error(`No Content with id ${id}`)
        )
      )
      .toPromise(),
  {
    cacheMap: new ExpiryMap(120),
    maxBatchSize: 15,
  }
  // { cacheMap: new ExpiryMap(60) }
);

export const useContentLoader = makeLoader(contentDataLoader);
